import PropTypes from 'prop-types'
import { Button } from 'chaoskit/src/components'
import { forwardRef } from 'react'

import Link from './Link'
import OutboundLink from './OutboundLink'

import { domainRegex, redirectPathsRegex } from '~utils/helpers'

// Used to help determine if links should use Gatsby's internal link-routing or open in a new window
const ButtonLink = forwardRef(({ url, ...rest }, ref) => {
  // If a URL isn't supplied, just pass this through as normal
  if (!url) {
    return <Button ref={ref} {...rest} />
  }

  const sameDomain = domainRegex.test(url)

  if (sameDomain) {
    url = url.replace(domainRegex, '/')
  }

  if (url.startsWith('/')) {
    // Treat partial URLs that have Netlify redirects as normal links
    if (redirectPathsRegex.test(url)) {
      return <Button ref={ref} url={url} {...rest} />
    }

    return <Button ref={ref} data-link-internal as={Link} to={url} {...rest} />
  }

  // Treat urls that aren't web protocols as "normal" links
  if (!url.startsWith('http')) {
    return <Button ref={ref} url={url} {...rest} />
  }

  return <Button as={OutboundLink} ref={ref} href={url} {...rest} />
})

ButtonLink.propTypes = {
  url: PropTypes.string,
}

export default ButtonLink
